import styles from './index.module.scss';
import { useTheme } from 'hooks/theme';

interface InfoLabelValueProps {
  label: string;
  value: string;
  customStyle?: any;
  valueClassName?: string;
}

const InfoLabelValue = ({
  label,
  value,
  customStyle,
  valueClassName,
}: InfoLabelValueProps) => {
  const { theme } = useTheme();
  return (
    <div className={`${styles.container}  ${styles[theme]} ${customStyle}`}>
      <label className={`${styles[theme]}`}>{label}</label>
      <p
        dangerouslySetInnerHTML={{ __html: value }}
        className={valueClassName}
      />
    </div>
  );
};

export default InfoLabelValue;
